export const languageCodes = ['en', 'ru', 'sr'] as const;

export const languages: LanguageItem[] = [
    { code: 'en', title: 'English' },
    { code: 'ru', title: 'Русский' },
    { code: 'sr', title: 'Srpski' },
];

export type LanguageCode = (typeof languageCodes)[number];

export interface LanguageItem {
    code: LanguageCode;
    title: string;
}

export const languageDefaultCode: LanguageCode = 'ru';
